import classNames from 'classnames';
import clsx from 'clsx';
import { getIsDemoFarm } from 'utils/general';

import { Typography } from '@/shared/components/atoms';
import { AssetItemProps } from '@/shared/components/molecules/ChooseAsset/ChooseAsset';

import Building from '~/images/shared/Building.svg';
import Farm from '~/images/shared/building-3.svg';
import FarmBlue from '~/images/shared/Building-3-Blue.svg';
import BuildingBlue from '~/images/shared/BuildingBlue.svg';

interface ListItemProps {
  data: AssetItemProps;
  active: boolean;
  onClick: () => void;
}
const ListItem: React.FC<ListItemProps> = ({ active, data, onClick }) => {
  const isDemoFarm = getIsDemoFarm(data);
  return (
    <div
      className={classNames(
        'cursor-pointer items-center rounded-xl p-9',
        active && !isDemoFarm && 'bg-blue-100',
        isDemoFarm && 'bg-neutralVariant-96 text-tertiary-20'
      )}
      onClick={onClick}
    >
      <div className='flex items-center gap-2'>
        <span
          className={clsx(
            isDemoFarm ? 'text-tertiary-20' : 'text-primary-default'
          )}
        >
          {data.entityTypeId === 2 ? (
            active ? (
              <FarmBlue width='24' height='24' />
            ) : (
              <Farm width='24' height='24' />
            )
          ) : active ? (
            <BuildingBlue width='24' height='24' />
          ) : (
            <Building width='24' height='24' />
          )}
        </span>
        <Typography
          className={classNames(
            'text-14',
            active ? 'font-semi-bold text-primary-400' : 'text-text-default',
            isDemoFarm && 'text-tertiary-20'
          )}
        >
          {data.name}
        </Typography>
      </div>
    </div>
  );
};
export default ListItem;
